import React from "react";

const PaymentPlanLoader = () => {
    return(
        <div className="payment_loader_cont">
            <div className="payment_loader_cont_inner fade-in"></div>
            <div className="payment_loader_cont_inner">
                <div className="loading_links fade-in" ></div>
                <div className="loading_links fade-in" ></div>
                <div className="loading_links fade-in" ></div>
                <div className="loading_links fade-in" ></div>
            </div>
        </div>
    )
}

export default PaymentPlanLoader